module.exports = __webpack_public_path__ + "../../../static/img/se_05.707a0606.png";